<!-- @Author Shyam @Date 26/03/2026 @Description:Decision workflow step Component -->
<div class="col-12 mt-4">
  <form *ngIf="validations_form" novalidate [formGroup]="validations_form">
    <!-- RULE LOOP -->
    <div formArrayName="rules">
      <div
        *ngFor="let rule of rules?.controls; let i = index"
        [formGroupName]="i"
        class="border rounded p-3 mb-4"
      >
        <!-- Rule Header -->
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h5 class="mb-0">Rule {{ i + 1 }}</h5>

          <!-- <button
            type="button"
            mat-raised-button
            color="warn"
            (click)="removeRule(i)"
            *ngIf="rules.length > 0"
          >
            ✕
          </button> -->
          <label
            (click)="removeRule(i)"
            *ngIf="rules.length > 0"
            style="
              margin-top: 6px;

              margin-bottom: auto;
              padding: 2px 5px 0px 5px;
              border-radius: 15px;
            "
            ><em
              class="fas fa-times"
              style="font-size: large"
              title="Close"
            ></em
          ></label>
        </div>

        <!-- Condition Type -->
        <!-- <mat-form-field appearance="fill" class="w-20 mb-1">
        <mat-label>Condition Type*</mat-label>
        <mat-select [(value)]="rule.conditionType">
          <mat-option [value]="'All conditions are met'"
            >All conditions are met</mat-option
          >
          <mat-option [value]="'Any conditions are met'"
            >Any conditions are met</mat-option
          >
        </mat-select>
      </mat-form-field> -->
        <mat-form-field appearance="outline" class="w-100">
          <mat-label i18n="@@Targetstdcode">Condition Type</mat-label>
          <mat-select formControlName="conditionType">
            <mat-option
              *ngFor="let option of conditionTypeOptions"
              [value]="option.value"
            >
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- IF Label -->
        <div class="mb-2">
          <label class="font-weight-bold">IF</label>
        </div>
        <div formArrayName="conditions">
          <div
            *ngFor="let condition of getConditions(i).controls; let j = index"
            [formGroupName]="j"
            class="row align-items-end mb-3"
          >
            <!-- SOURCE (always visible) -->
            <div class="col-lg-3 col-md-6 col-12">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Type</mat-label>
                <mat-select
                  formControlName="selectedSource"
                  (selectionChange)="onSourceChange(i, j)"
                >
                  <mat-option [value]="''">Select</mat-option>
                  <mat-option *ngFor="let s of sources" [value]="s">
                    {{ s }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- FIELD (only after source selected) -->
            <div
              class="col-lg-3 col-md-6 col-12"
              *ngIf="condition.get('selectedSource')?.value"
            >
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Field</mat-label>
                <mat-select
                  formControlName="selectedField"
                  (selectionChange)="onFieldChange(i, j)"
                >
                  <mat-option
                    *ngFor="let f of condition.get('fields')?.value"
                    [value]="f"
                  >
                    {{ f }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- OPERATOR (only after field selected) -->
            <div
              class="col-lg-3 col-md-6 col-12"
              *ngIf="condition.get('selectedField')?.value"
            >
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Operator</mat-label>
                <mat-select formControlName="selectedOperator">
                  <mat-option
                    *ngFor="let op of condition.get('operators')?.value"
                    [value]="op"
                  >
                    {{ op }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- VALUE (only after operator selected) -->
            <div
              class="col-lg-2 col-md-6 col-12"
              *ngIf="condition.get('selectedOperator')?.value"
            >
              <mat-form-field appearance="outline" class="w-100">
                <ng-container
                  *ngIf="
                    condition.get('selectedSource')?.value === 'Task';
                    else inputField
                  "
                >
                  <mat-select formControlName="value">
                    <mat-option *ngFor="let v of verdicts" [value]="v">
                      {{ v }}
                    </mat-option>
                  </mat-select>
                </ng-container>

                <!-- fallback to input -->
                <ng-template #inputField>
                  <input
                    matInput
                    placeholder="Enter value"
                    formControlName="value"
                  />
                </ng-template>
              </mat-form-field>
            </div>

            <!-- DELETE -->
            <div
              class="col-lg-1 col-md-6 col-12 text-center"
              style="padding: 30px"
            >
              <label
                (click)="removeCondition(i, j)"
                *ngIf="isConditionComplete(condition)"
                style="
                  margin-top: 6px;

                  margin-bottom: auto;
                  padding: 2px 5px 0px 5px;
                  border-radius: 15px;
                "
                ><em
                  class="fas fa-times"
                  style="font-size: large"
                  title="Close"
                ></em
              ></label>
            </div>
          </div>
        </div>
        <!-- ADD CONDITION BUTTON -->
        <div class="mb-3">
          <label
            (click)="addCondition(i)"
            *ngIf="isLastConditionComplete(i)"
            style="
              margin-top: 6px;
              background: green;
              margin-bottom: auto;
              padding: 2px 5px 0px 5px;
              border-radius: 15px;
            "
            ><em
              class="fas fa-plus"
              style="color: antiquewhite; font-size: large"
              title="+ Add Condition"
            ></em
          ></label>
        </div>
        <!-- THEN -->
        <div class="col-md-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Then</mat-label>
            <mat-select formControlName="thenAction">
              <mat-option *ngFor="let task of tasks" [value]="task.stepid">
                {{ task.stepname }}
              </mat-option>
              <!-- <mat-option value="PLACEHOLDER">+ Create New Step</mat-option> -->
              <!-- <ng-container
                *ngIf="verdicts && verdicts.length > 0; else defaultOptions"
              >
                <mat-option *ngFor="let v of verdicts" [value]="v">
                  {{ v }}
                </mat-option>
              </ng-container> -->

              <!-- Fallback -->
              <!-- <ng-template #defaultOptions>
                <mat-option value="Start QC">Start QC</mat-option>
                <mat-option value="Send Email">Send Email</mat-option>
                <mat-option value="Reject">Reject</mat-option>
              </ng-template> -->
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <!-- ADD RULE BUTTON -->
    <!-- <button mat-raised-button color="primary" type="button" (click)="addRule()">
      + Add Rule
    </button> -->
    <label
      (click)="addRule()"
      style="
        margin-top: 6px;
        background: green;
        margin-bottom: auto;
        padding: 2px 5px 0px 5px;
        border-radius: 15px;
      "
      ><em
        class="fas fa-plus"
        style="color: antiquewhite; font-size: large"
        title="+ Add Rule"
      ></em
    ></label>
  </form>
</div>
